import styled from 'styled-components';

const ShowstopperGridContainer = styled.div<{
    columnCount: number;
}>`
    position: relative;
    height: 100%;
    overflow: hidden;
    width: 100%;
    grid-column: 1 / span ${props => props.columnCount};
`;

const ShowstopperMobileContainer = styled.div`
    margin-bottom: 3%;
`;

export { ShowstopperGridContainer, ShowstopperMobileContainer };
